import React from 'react';

/**
 * What a report shows when its request FAILED, as opposed to when it answered with nothing.
 *
 * Every one of these hooks falls back to an empty payload when the request rejects, so the screen always
 * has something to render - and that made the two cases identical on screen. A broken request drew 0%
 * paid, an empty table, or a block that simply was not there, and read as a real business result. The
 * toast that fires alongside is transient, so a producer who looked away saw a month with no sales
 * instead of a report that could not load.
 *
 * Deliberately neither an empty state nor a zero: "não foi possível carregar" is the one thing a number
 * cannot say for itself.
 */
export const ReportUnavailable = () => (
  <div className="py-main text-center">
    <p className="text-sm text-lightBlack">
      Não foi possível carregar estes números agora.
    </p>
  </div>
);
